export default {
  clientActivated: 'Client\'s account has been activated. '
    + 'Invitation(s) to company admin(s) has been successfully sent.',
  clientDeactivated: 'Client\'s account has been deactivated. '
    + 'All users have been deactivated too.',
  userInvited: 'Invitation has been sent',
  userInvitedError: 'Error invitation: {{error}}',
  userActivated: 'The user has been activated',
  userDeactivated: 'The user has been deactivated',
  userDeleted: 'The user has been deleted',
  informationUpdated: 'The information has been updated',
  userResetPassword: 'Reset password link has been sent to the user. '
    + 'This does not change their password, nor does it force a change.',
  userResetMfa: 'MFA has been reset. The user will be required to set it up again during their next login.',
  userUpdated: 'The information has been updated',
  userCreatedInDraftStatus: 'The user has been created in draft status',
  passwordSuccessfullyChanged: 'You password has been changed',
  unableSaveNewPassword: 'Unable to save the new password. Please check your information and try again',
  mfaCreated: 'MFA has been successfully created',
  somethingWentWrong: 'Something went wrong. Please try again later',
  clientCreatedInDraft: 'The client has been created in draft status',
  informationUpdatedAndSendInvite: 'The information has been updated. Invitation to the user has been '
      + 'successfully sent.',
  recordHasBeenAdded: 'The record has been added',
  recordHasBeenUpdated: 'The record has been updated',
  recordHasBeenArchived: 'The record(s) has been archived',
  recordHasBeenDeArchived: 'The record has been restored',
  statusHasBeenUpdated: 'Status has been updated.',
  valueChainMapHasBeenRenamed: 'Value Chain Map has been renamed.',
  valueChainMapHasBeenDeleted: 'Value Chain Map has been deleted.',
  valueChainMapHasBeenArchived: 'Value Chain Map has been archived.',
  valueChainMapHasBeenApproved: 'Value Chain Map has been approved.',
  valueChainMapHasBeenReWork: 'Value Chain Map has been returned for re-work.',
  valueChainMapHasBeenDeArchived: 'Value Chain Map has been restored.',
  valueChainMapHasBeenDublicated:
    'Value Chain Map duplication may take a few minutes. You will be notified once it\'s ready',
  valueChainMapHasBeenCreated: 'Value Chain Map creation may take a few minutes. You will be notified once it\'s ready',
  valueChainMapNameHasBeenCreated: 'Value Chain Map {{name}} has been created',
  swimlaneHasBeenAdded: 'Swimlane has been added',
  swimlaneHasBeenRenamed: 'Swimlane has been renamed',
  swimlaneHasBeenDeleted: 'Swimlane has been deleted',
  swimlaneCannotBeDeleted: 'Swimlane cannot be deleted because it contains units',
  swimlaneAlreadyExists: 'Swimlane with this name already exists',
  surveyHasBeenDeleted: 'Survey has been deleted',
  errorDeletingSurvey: 'Error deleting survey. Please try again later',
  surveyHasBeenDuplicated: 'Survey has been duplicated',
  errorDuplicatingSurvey: 'Error duplicating survey. Please try again later',
  surveySharedSuccessfully: 'Survey has been shared successfully',
  errorHandlerTextMessage: '{{message}}. Please try again later.',
  jobPositionUpdated: 'Job position has been updated',
  errorJobPositionUpdate: 'Error updating job position',
  materialAssessmentCreated: 'Material Assessment has been created',
  errorMaterialAssessmentCreate: 'Error creating Material Assessment',
  materialAssessmentUpdated: 'Material Assessment has been updated',
  errorMaterialAssessmentUpdate: 'Error updating Material Assessment',
  stakeholderUpdated: 'Stakeholder has been updated',
  errorStakeholderUpdate: 'Error updating Stakeholder',
  topicStatusUpdated: 'Topic status has been updated',
  errorTopicStatusUpdate: 'Error updating Topic status',
  saveSelectedSuppliers: 'Selected suppliers list have been saved',
  errorSaveSelectedSuppliers: 'Error saving selected suppliers list',
  deleteSelectedSuppliers: 'Selected suppliers have been deleted from the list',
  errorDeleteSelectedSuppliers: 'Error deleting selected suppliers from the list',
  createdInvestor: 'Investor has been created',
  updatedInvestor: 'Investor has been updated',
  deletedInvestor: 'Investor has been deleted',
  errorDeleteInvestor: 'Error deleting investor',
  createdBoard: 'Board member has been created',
  updatedBoard: 'Board member has been updated',
  deletedBoard: 'Board member has been deleted',
  errorDeleteBoard: 'Error deleting board member',
  createdEmployee: 'Employee has been created',
  updatedEmployee: 'Employee has been updated',
  deletedEmployee: 'Employee has been deleted',
  errorDeleteEmployee: 'Error deleting employee',
  saveSelectedCustomers: 'Selected customers list have been saved',
  errorSaveSelectedCustomers: 'Error saving selected customers list',
  deleteSelectedCustomers: 'Selected customers have been deleted from the list',
  errorDeleteSelectedCustomers: 'Error deleting selected customers from the list',
  createdCommunities: 'Selected communities list have been created',
  updatedCommunities: 'Selected communities list have been updated',
  deleteSelectedCommunities: 'Selected communities have been deleted from the list',
  errorDeleteSelectedCommunities: 'Error deleting selected communities from the list',
  createdMedia: 'Media has been created',
  updatedMedia: 'Media has been updated',
  deletedMedia: 'Media has been deleted',
  errorDeleteMedia: 'Error deleting media',
  createdNGO: 'NGO has been created',
  updatedNGO: 'NGO has been updated',
  deletedNGO: 'NGO has been deleted',
  errorDeleteNGO: 'Error deleting NGO',
  uploadQuestionsSuccess: 'Questions have been successfully uploaded',
  selectedQuestionsGroup: 'Selected questions group have been saved',
  errorSelectedQuestionsGroup: 'Error saving selected questions group',
  createQuestionGroup: 'Question group has been created',
  createdCompetitor: 'Competitor has been created',
  deletedCompetitor: 'Competitor has been deleted',
  errorDeleteCompetitor: 'Error deleting Competitor',
  updateInformationSuccess: 'Information has been updated successfully',
  errorUpdateInformation: 'Error updating information',
  updateRecordSuccess: 'Record has been updated successfully',
  errorUpdateRecord: 'Error updating record',
  createdGeoRisk: 'Geographic Specific risk has been created',
  updatedGeoRisk: 'Geographic Specific risk list has been updated',
  errorUpdateGeoRisk: 'Error updating Geographic Specific risk list',
  refreshGeoRisk: 'Geographic Specific risk list has been refreshed',
  errorRefreshGeoRisk: 'Error refreshing Geographic Specific risk list',
  deletedGeoRisk: 'Geographic Specific risk has been deleted',
  errorDeleteGeoRisk: 'Error deleting Geographic Specific risk',
  createdSectorRisk: 'Sector risk has been created',
  updatedSectorRisk: 'Sector risk has been updated',
  errorUpdateSectorRisk: 'Error updating Sector risk',
  refreshSectorRisk: 'Sector risk has been refreshed',
  errorRefreshSectorRisk: 'Error refreshing Sector risk',
  deletedSectorRisk: 'Sector risk has been deleted',
  errorDeleteSectorRisk: 'Error deleting Sector risk',
  deleteIROItem: '{{itemName}} has been deleted',
  errorDeleteIROItem: 'Error deleting {{itemName}}',
  createdIROItem: '{{itemName}} has been created',
  errorCreateIROItem: 'Error creating {{itemName}}',
  updatedIROItem: '{{itemName}} has been updated',
  errorUpdateIROItem: 'Error updating {{itemName}}',
  resendIROEmail: 'Email has been resent',
  errorResendEmail: 'Unable to resend email',
  errorCooldownResendEmail: 'Please wait before resending. This may take up to 10 minutes',
  addedSelectedTemplates: 'Selected templates have been added',
  errorAddSelectedTemplates: 'Error adding selected templates. Please try again later',
  updateTopicRefinement: 'Topic Refinement has been updated',
  errorUpdateTopicRefinement: 'Error updating Topic Refinement. Please try again later',
  uploadQuestionsError: 'Error uploading questions file, wrong "{{nameColumn}}" column value',
  uploadQuestionsError2: 'Error uploading questions file',
  sentQuestionary: 'Questionary has been sent',
  errorSendQuestionary: 'Error sending questionary. Please try again later',
  createdRecipientUsers: 'Recipient users have been created',
  errorCreatedRecipientUsers: 'Error creating recipient users. Please try again later',
  swimlaneOrderIndexHasBeenUpdated: 'Swimlane order index has been updated',
  cannotMoveSwimlaneAcrossBoards: 'Swimlanes cannot be moved between different Value Chain Positions',
  valueChainPlacementSupplierOutsideUpstream:
    'Suppliers can only be placed in the upstream section. If a third party is a '
    + 'supplier and is owned by your organisation, then that should be shown as a '
    + 'supplier in the upstream section and labelled accordingly.',
  valueChainPlacementProductInputOutsideUpstream:
    'Product Input can only be placed in the upstream section. If a third party '
    + 'Product Input is supplied by your organisation, then that should be shown as '
    + 'a Product Input in the upstream section.',
  valueChainPlacementCustomerOutsideDownstream:
    'Customers can only be placed in the downstream section. If a third party is a '
    + 'customer and is owned by your organisation, then that should be shown as a customer in the downstream section.',
  valueChainPlacementOwnOperationsOutsideSection:
    'Own operations can only be placed in the own operations section. If a company '
    + 'entity is a customer or a supplier and is owned by your organisation, then that '
    + 'should be shown as a customer in the downstream section or supplier in the upstream.',
  valueChainPlacementOutputProductOutsideOwnOperations:
    'Output Product can only be placed in the own operations section. If a third party '
    + 'Output Product is produced by your organisation, then that should be shown as '
    + 'an Output Product in the own operations section.',
  valueChainPlacementOutsideSection: 'Cards cannot be placed outside a section.',
  profitCenterRequiredBeforeEntityCreation:
    'Create at least one Profit Center before adding other entity types to the Value Chain.',
  valueChainMaxNestingDepthExceeded:
    'Cannot move this card here: its nested cards would exceed the maximum depth.',
  valueChainUnitsAddedToSession: 'Units have added to session',
  valueChainUnitsAddedToSessionError: 'Units haven`t added to session',
  valueChainMapDuplicatedError: 'Error duplicating Value Chain Map. {{error}}',
  valueChainMapCreateError: 'Error creating Value Chain Map. {{error}}',
  materialAssessmentDraftSaved: 'Material Assessment has been saved as draft',
  errorMaterialAssessmentDraftSave: 'Error saving Material Assessment as draft',
  materialAssessmentDraftUpdated: 'Material Assessment has been updated as draft',
  errorMaterialAssessmentDraftUpdate: 'Error updating Material Assessment as draft',
  recordHasBeenDeleted: 'The record has been deleted',
  valueChainMapDeleteError: 'Error deleting Value Chain Map.',
  valueChainMapArchiveError: 'Error archiving Value Chain Map.',
  valueChainMapArchiveError2: 'Value Chain Map cannot be archived. {{error}}',
  valueChainMapDeleteError2: 'Value Chain Map cannot be deleted. {{error}}',
  materialAssessmentApproved: 'Material Assessment has been approved',
  materialAssessmentRejected: 'Material Assessment has been rejected',
  valueChainStartSessionError: 'Error starting session',
  valueChainBomUnitsLinesNotFilled: 'Some BOM lines are not filled.',
  valueChainBomUnitsLineNotFilled: 'Line {{lineNumber}} is not filled. Please complete all required fields.',
  valueChainBomUnitsNoManufacturerSelected: 'Please select at least one manufacturer before generating with AI.',
  valueChainBomUnitsNoSupplierSelected: 'Please select at least one supplier before generating with AI.',
  valueChainBomUnitsProcessingEditBlocked: 'This item cannot be edited while AI processing is active.',
  valueChainBomUploadSuccess: 'BOM file has been successfully uploaded',
  valueChainSupplierUploadSuccess: 'Supplier file has been successfully uploaded',
  valueChainSupplierUnitsLinesNotFilled: 'Some supplier rows are not filled.',
};
